var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRec77(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 122,
    viewBox: "0 0 76 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 121.256,
    width: 161.097,
    height: 93,
    rx: 46.5,
    transform: "rotate(-90 0 121.256)",
    fill: "url(#paint0_linear_234_571)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_234_571",
    x1: 31.908,
    y1: 80.3356,
    x2: 266.266,
    y2: 296.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3652E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505205,
    stopColor: "#8057F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989515,
    stopColor: "#7851E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989615,
    stopColor: "#8057F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRec77);
export default __webpack_public_path__ + "static/media/REC77.afe1e1d7e444ba28359895d7bd823bcc.svg";
export { ForwardRef as ReactComponent };